import { useMemo } from 'react';
import { MAX_PRODUCTS } from 'components/Catalog/ProductGrid/CompareModal/constants';

/**
 * Shared hook for processing comparison availability data
 * @param {Object} comparisonData - The comparison data object containing skus and availabilityForSitePages
 * @returns {Array} Array of availabilityDetails objects aligned by sku position, length MAX_PRODUCTS
 */
export const useComparisonAvailability = (comparisonData = {}) => {
    return useMemo(() => {
        const availabilityByProducts = comparisonData?.availabilityForSitePages?.availabilityByProducts || [];
        const availabilityMap = new Map(availabilityByProducts.map(entry => [entry?.sku?.skuId, entry?.availabilityDetails]));

        return Array.from({ length: MAX_PRODUCTS }, (_, index) => {
            const skuId = comparisonData?.skus?.[index]?.skuId;

            return skuId ? availabilityMap.get(skuId) : undefined;
        });
    }, [comparisonData?.availabilityForSitePages, comparisonData?.skus]);
};

export default useComparisonAvailability;
